import { AuthenticateModel } from "../../app/models/authenticateModel";
import { AuthenticateResultModel } from "../../app/models/authenticateResultModel";
import { Router } from "@angular/router";
import { SessionService } from "../../app/services/session.service";
import { RestClientService } from "../../app/services/restclient.service";
import { Injectable } from "@angular/core";
import { UserService } from "../../app/services/user.service";
import { User } from "../../app/models/user";
import { BlockUIService } from "../../app/services/blockui.service";
import { AuthToken } from "../../app/models/auth-token";
import { Site } from "../models/site";
import { CookieService } from "ngx-cookie-service";

@Injectable()
export class LoginService {
  authenticateModel: AuthenticateModel;
  authenticateResult: AuthenticateResultModel;
  rememberMe: boolean;
  token: AuthToken = new AuthToken();
  returnUrl: string;

  user1: User = new User();
  sites: Site[];

  constructor(
    private serviceAuth: RestClientService,
    private _userService: UserService,
    private router: Router,
    private session: SessionService,
    private blockUI: BlockUIService,
    private cookieService: CookieService
  ) {
    this.clear();
  }
  authenticate(value: AuthenticateModel) {
    // Call authtenticate Api
    this._userService.authenticate(value).subscribe((result: any) => {
      //console.log("user", result);
      this.token.token = result.body.data.authorise_token;
      this.token.token_link = result.body.data.authorise_link;
      //this.setSites(result.body.scope);
      this.sites = result.body.scope;
      this.user1.login = result.body.user.user_name;
      //console.log("sites" + JSON.stringify(this.sites));
      this.processAuthenticateResult(result.body);
      this.cookieService.set("User", JSON.stringify(result.body.user));
      this.cookieService.set("UserData", JSON.stringify(result.body.data));
    });
  }

  getSites(): Site[] {
    return this.session.getSites();
  }
  private processAuthenticateResult(
    authenticateResult: AuthenticateResultModel
  ) {
    this.authenticateResult = authenticateResult;
    // Check if token is available
    if (authenticateResult.data.authorise_token) {
      this.session.authenicated(this.token, this.sites, this.user1.login);
      this.login(authenticateResult.data.authorise_token);

      // Getting User Details
      //   this._userService.getUser(true).subscribe(
      //     user => {
      //       this.user1 = user.body;
      //       console.log(this.user1)

      //       this.login(authenticateResult.id_token);

      //     });
    } else {
      // REDIRECT TO lOGIN PAGE
      this.router.navigate(["account/login"]);
    }
  }

  private login(accessToken: string): void {
    // var tokenExpireDate = rememberMe ? (new Date(new Date().getTime() + 1000 * expireInSeconds)) : undefined;
    if (this.authenticateResult.data.authorise_token) {
      // Get the redirect URL from our auth service
      // If no redirect has been set, use the default
      //console.log("sasdas");
      //this.router.navigate(['/dashboard']);;
      this.blockUI.stopBlockHold();
    }
  }

  private clear(): void {
    this.authenticateModel = new AuthenticateModel();
    // this.authenticateModel.rememberMe = false;
  }
}
